var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-stretc flex-grow-1 w-100"},[_c('object',{staticClass:"flex-grow-0 mt-1",staticStyle:{"min-width":"65em"},attrs:{"data":_vm.url,"type":"application/pdf"}},[_c('embed',{attrs:{"src":_vm.url,"type":"application/pdf"}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2205c069","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/admin/info/agreement.vue
// module id = null
// module chunks = 